/**
 * @file_purpose  page for showing video portfolio details 
 * @author Sucheta Singha
 * @Date_Created 20-09-2024
 * @Date_Modified 20-09-2024
 */
import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { FaVolumeUp, FaVolumeMute, FaThumbsUp, FaThumbsDown } from "react-icons/fa"; // Icons from react-icons
import RouteURL from "src/apis/ApiURL";
import Constants from 'src/Utility/Constants';
import {
    CSpinner
} from '@coreui/react'
import GeneralService from 'src/apis/GeneralService';
import video1 from '../../../assets/icons/portfolio_video1.mp4'
// import video2 from '../../../assets/icons/portfolio_video2.mp4'
// import video3 from '../../../assets/icons/portfolio_video3.mp4'
// import portfolio1 from '../../../assets/icons/vid_logo1.png'
// import portfolio2 from '../../../assets/icons/vid_logo2.png'
// import portfolio3 from '../../../assets/icons/vid_logo3.png'
export default function VideoPortfolioDetails() {

    // const video_list = [
    //     {
    //         id: 1,
    //         title: "Red Apple 2D Art Portfolio",
    //         videoUrl: video1,
    //         thumbnail: portfolio1,
    //         like_count: 175,
    //         dislike_count: 0,
    //         is_liked: 0,
    //         is_disliked: 0
    //     },
    //     {
    //         id: 2,
    //         title: "3D Art Portfolio",
    //         videoUrl: video2,
    //         thumbnail: portfolio2,
    //         like_count: 176,
    //         dislike_count: 1,
    //         is_liked: 0,
    //         is_disliked: 1
    //     },
    //     {
    //         id: 3,
    //         title: "Casino & Slots",
    //         videoUrl: video3,
    //         thumbnail: portfolio3,
    //         like_count: 177,
    //         dislike_count: 2,
    //         is_liked: 1,
    //         is_disliked: 0
    //     },
    // ];

    const history = useHistory();
    const location = useLocation();
    const [videoList, setVideoList] = useState([]);
    const [currentVideo, setCurrentVideo] = useState({});
    const [isMuted, setIsMuted] = useState(false);
    const [volume, setVolume] = useState(1); // Default volume at 100%
    const [likes, setLikes] = useState(175); // Example number of likes
    const [dislikes, setDislikes] = useState(0); // Example number of dislikes
    const videoRef = useRef(null);
    const [playButton, setPlayButton] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [loader, setLoader] = useState(1);
    const [videoId, setVideoId] = useState(1);




    useEffect(() => {
        if (location.state) {
            if (location.state.otp_verified_status != "1") {
                if (localStorage.getItem('video_portfolio_verify_otp') != "1") {
                    history.push("/video-portfolio")
                }
            }

        } else {
            if (localStorage.getItem('video_portfolio_verify_otp') != "1") {
                history.push("/video-portfolio")
            }
        }
    }, []);

    useEffect(() => {
        /**
        * @author Sucheta Singha
        * @Date_Created 24/09/2024
        * @Date_Modified 24/09/2024
        * @function async
        * @functionName loadVideoList
        * @functionPurpose this function gets video list by filter wise.
        *
        * @functionParam {payload object:contact_id}
        * 
        * @functionSuccess Success status and message.
        *
        * @functionError {Boolean} error is there.
        * @functionError {String} message  Description message.
        */
        async function loadVideoList() {
            setLoader(1)
            // console.log(localStorage.getItem('video_portfolio_contact_id'));
            let params = {
                contact_id: location.state ? (location.state.contact_id ? location.state.contact_id : localStorage.getItem('video_portfolio_contact_id')) : localStorage.getItem('video_portfolio_contact_id'),

            }
            GeneralService.apiPostCallRequestWithoutToken(RouteURL.videoPortfolioList, params)
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        setVideoList(res.data)
                        // if (Object.keys(currentVideo).length == 0) {
                        let video_obj = res.data.find(p => p.id == videoId)
                        // console.log(video_obj);

                        setCurrentVideo(video_obj)
                        // }
                        if (videoRef.current) {
                            videoRef.current.load();
                            videoRef.current.play();
                        }
                        setLoader(0)
                        setLoadingData(false)
                    }
                    else {

                    }
                }).catch(error => {
                    console.log(error);

                })
        }

        if (loadingData) {
            // if the result is not ready so you make the axios call
            loadVideoList()
        }


    }, [loadingData]);

    const handleVideoSelect = (video) => {
        setCurrentVideo(video);

        if (videoRef.current) {
            videoRef.current.load();
            videoRef.current.play();
        }
    };

    // const togglePlayPause = () => {
    //     if (videoRef.current.paused) {
    //         videoRef.current.play();
    //         setPlayButton(true)
    //     } else {
    //         setPlayButton(false)
    //         videoRef.current.pause();
    //     }
    // };

    // const toggleMute = () => {
    //     setIsMuted(!isMuted);
    //     videoRef.current.muted = !isMuted;
    // };

    // const handleVolumeChange = (e) => {
    //     const volumeValue = e.target.value;
    //     setVolume(volumeValue);
    //     videoRef.current.volume = volumeValue;
    // };

    const toggleFullscreen = () => {
        if (videoRef.current.requestFullscreen) {
            videoRef.current.requestFullscreen();
        } else if (videoRef.current.mozRequestFullScreen) {
            videoRef.current.mozRequestFullScreen();
        } else if (videoRef.current.webkitRequestFullscreen) {
            videoRef.current.webkitRequestFullscreen();
        } else if (videoRef.current.msRequestFullscreen) {
            videoRef.current.msRequestFullscreen();
        }
    };
    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });



    const [isFullScreen, setIsFullScreen] = useState(false);
    const toggleFullScreen = () => {
        setIsFullScreen((prev) => !prev);
    };


    /**
* @author Sucheta Singha
* @Date_Created 19-10-2023
* @Date_Modified 19-10-2023
* @function sync
* @functionName SendEmailSubmit
* @functionPurpose this function delete project.
*
* @functionParam {payload object:project_id}
* 
* @functionSuccess Success status and message.
*
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/

    const updateLikeDislikeCount = (e, video_id, type, is_liked_disliked) => {
        setVideoId(video_id)
        let params = JSON.stringify({
            contact_id: location.state ? (location.state.contact_id ? location.state.contact_id : localStorage.getItem('video_portfolio_contact_id')) : localStorage.getItem('video_portfolio_contact_id'),
            is_liked: type == "like" && is_liked_disliked == 0 ? 1 : 0,
            is_disliked: type == "dislike" && is_liked_disliked == 0 ? 1 : 0,
            video_id: currentVideo.id,
        });

        GeneralService.apiPostCallRequestWithoutToken(RouteURL.videoPortfolioLikeDislikeUpdate, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    getVideoDetails()
                }

            }).catch(error => {
                console.log(error);
            })
    }

    const getVideoDetails = () => {
        let params = {
            contact_id: location.state ? (location.state.contact_id ? location.state.contact_id : localStorage.getItem('video_portfolio_contact_id')) : localStorage.getItem('video_portfolio_contact_id'),

        }
        GeneralService.apiPostCallRequestWithoutToken(RouteURL.videoPortfolioList, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    let video_arr = [...videoList];
                    let video_Index = res.data.findIndex(p => p.id == videoId);
                    let video_obj = res.data.find(p => p.id == videoId)
                    video_arr[video_Index]["like_count"] = video_obj.like_count;
                    video_arr[video_Index]["dislike_count"] = video_obj.dislike_count;
                    video_arr[video_Index]["is_liked"] = video_obj.is_liked;
                    video_arr[video_Index]["is_disliked"] = video_obj.is_disliked;
                    setVideoList(video_arr)
                }

            }).catch(error => {
                console.log(error);

            })
    };
    return (

        <body style={{ backgroundColor: "#fff" }}>
            <div className="video_detail_container">
                <div className="video-section">
                    <video
                        ref={videoRef}
                        controls
                        id="videoPlayer"
                        className="video-player"
                        // muted={isMuted}
                        // volume={volume}
                        // onClick={toggleFullScreen}
                        controlsList="nodownload"
                        style={{
                            width: '100%', // Adjust the sizes as needed
                            height: isFullScreen ? '100%' : '674px',
                            transition: 'width 0.3s, height 0.3s',
                        }}
                    >
                        <source src={currentVideo.videoUrl} type="video/mp4" />

                    </video>


                    {/* <div className="controls">
                        <button onClick={togglePlayPause}>
                            {videoRef.current && playButton ?
                                <i class="fa fa-pause" style={{ fontSize: 24 }}>
                                </i>

                                : <i class="fa fa-play" style={{ fontSize: 24 }}></i>}
                        </button>
                        <div className="volume-controls">
                            <button onClick={toggleMute}>
                                {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                            </button>
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={volume}
                                onChange={handleVolumeChange}
                                disabled={isMuted}
                            />
                        </div>
                        <button onClick={toggleFullscreen}><i class="fas fa-expand"></i></button>
                    </div> */}
                    {/* <button onClick={toggleFullscreen}><i class="fas fa-expand"></i></button> */}
                    <div className="controls">
                        <p>{currentVideo.title}</p>
                        <div className="like-dislike-buttons">
                            <button className="like-button" style={{ fontSize: 14, fontWeight: 500, color: currentVideo.is_liked == 1 ? "#e94b3c" : "#fff" }}
                                onClick={(e) => updateLikeDislikeCount(e, currentVideo.id, "like", currentVideo.is_liked)}
                            >
                                <i class="fa-solid fa-thumbs-up" ></i> {currentVideo.like_count}
                            </button>
                            <button
                                className="dislike-button"
                                style={{ color: currentVideo.is_disliked == 1 ? "#e94b3c" : "#fff" }}
                                onClick={(e) => updateLikeDislikeCount(e, currentVideo.id, "dislike", currentVideo.is_disliked)}

                            >
                                <i class="fa-solid fa-thumbs-down" ></i> {currentVideo.dislike_count}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="video-list-section">
                    {videoList.map((video) => (
                        <div
                            key={video.id}
                            className={`video-thumbnail ${currentVideo.id === video.id ? "active" : ""
                                }`}
                            onClick={() => handleVideoSelect(video)}
                        >
                            {/* <h4>{video.title}</h4>
                            <img src={video.thumbnail} width={"100%"} height={270}></img> */}

                            <div className='video_portfolio_box1'>
                                <img src={video.thumbnail} width={"100%"}></img>
                                <a className='watch_now' href="#" onClick={() => handleVideoSelect(video)}>Watch Now <i class="fa-solid fa-play"></i></a>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </body>
    );
};


